<div class="row mb-2">
  <div class="col-12 text-center">
    <i class="fas fa-user-lock fa-5x text-primary"></i>
  </div>
</div>

<div class="row mb-2">
  <div class="col-12 text-center">
    <p><b>{{"onboarding.privacy-policy-modal.privacy-label" | translate}}</b>{{"onboarding.privacy-policy-modal.privacy1-modal" | translate}}</p>
  </div>
</div>

<div class="row mb-2">
  <div class="col-12 text-center">
    <p>{{"onboarding.privacy-policy-modal.privacy2-modal" | translate}}</p>
  </div>
</div>

<div class="row mb-2">
  <div class="col-12 text-center">
    <p>{{"onboarding.privacy-policy-modal.privacy3-modal" | translate}}</p>
  </div>
</div>

<div class="row mb-2">
  <div class="col-12 text-center">
    <p style="font-size: 25px">{{"onboarding.privacy-policy-modal.privacy4-modal" | translate}} <a class="text-center" href="/privacy" target="_blank">{{"onboarding.privacy-policy-modal.privacy-label" | translate}}</a></p>
  </div>
</div>


<div class="row mb-2">
  <div class="col-12 text-center">
    <button class="btn btn-primary" type="button" (click)="closeModal()" >{{"onboarding.privacy-policy-modal.continue" | translate}}</button>
  </div>
</div>
